export const createEmployee = {
	addModal: {
		passwordRules: {
			minLength: "Tiene al menos 6 caracteres",
			minLetter: "Contiene al menos una letra",
		},
		errors: {
			invalidPassword:
				"Contraseña inválida, verifique si todos los requisitos están cumplidos",
		},
	},
};
